import { initialBaseState } from './base';
import { servicesInitialState } from './services';
import { navigationInitialState } from './navigation';
import { AppState } from './store';
import { userInputInitialState } from './userInput';
import { tempDataInitialState } from './tempData';

export const initialStateMock: AppState = {
	baseState: {
		...initialBaseState,
	},
	servicesState: {
		...servicesInitialState,
	},
	userInputState: {
		...userInputInitialState,
	},
	navigationState: {
		...navigationInitialState,
	},
	tempDataState: {
		...tempDataInitialState,
	},
};
